import classnames from "classnames";
import React from "react";

import styles from "./Chevron.module.scss";

type Props = {
  className?: string;
  onClick?: () => void;
  rotate?: boolean;
};

export default function Chevron({ className, onClick, rotate }: Props) {
  return (
    <i
      onClick={onClick}
      className={classnames("fa fa-angle-down", styles.icon, className, {
        [styles.rotate]: rotate
      })}
    />
  );
}
